import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

class VesselOwnerdt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: false,
        },
      },
      {
        label: "Company Name",
        name: "company_name",
        options: {
          filter: true,
        },
      },
      {
        label: "Company Code",
        name: "company_code",
        options: {
          filter: true,
        },
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let company_code = tableMeta.rowData !== undefined ? tableMeta.rowData[2] : "";
            let company_name = tableMeta.rowData !== undefined ? tableMeta.rowData[1] : "";
            if (localStorage.getItem("userlevel") != 3) {
              return (
                <div>
                  <Button
                    color="behance"
                    round
                    onClick={() => this.props.handleUpdate(company_code, company_name)}
                  >
                    Manage Access
                  </Button>
                </div>
              );
            } else {
              return <div />;
            }
          },
        },
      },
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader
            ? "Searching..."
            : "Sorry, no matching records found",
        },
      },
    };

    return (
      <MUIDataTable
        title={"Vessel Owner"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default VesselOwnerdt;
